// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import horizontalBarChart01Icon from "@/assets/icons/horizontal-bar-chart-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type HorizontalBarChart01IconProps = Omit<IconProps, "name">;

export function HorizontalBarChart01Icon(props: HorizontalBarChart01IconProps): React.ReactNode {
  return <Icon name={horizontalBarChart01Icon} {...props} />;
}
